/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_EmptyInputs */

const cs_deal_payments_empty = /** @type {(inputs: Deal_Payments_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné platby.`)
};

const en_deal_payments_empty = /** @type {(inputs: Deal_Payments_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payments yet.`)
};

/**
* | output |
* | --- |
* | "No payments yet." |
*
* @param {Deal_Payments_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_empty = /** @type {((inputs?: Deal_Payments_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_empty(inputs)
	return cs_deal_payments_empty(inputs)
});